import * as React from "react";

export default function SolidVerticalLineDivider(props: {}) {
  return (
    <div className="border-l border-[1px] border-solid border-[rgba(37,44,59,1)] h-2/3" />
  );
}
